import { FormattedMessage } from 'dibs-react-intl';

const copy = {
    negotiatingPrices: (
        <FormattedMessage
            id="ContactHelpArticles.negotiatingPrices"
            defaultMessage="Negotiating Prices"
        />
    ),
    negotiatingPricesDescription: (
        <FormattedMessage
            id="ContactHelpArticles.negotiatingPricesDescription"
            defaultMessage="We recommend these best practices to improve the likelihood of getting the price you want."
        />
    ),
    onlinePayment: (
        <FormattedMessage
            id="ContactHelpArticles.onlinePayment"
            defaultMessage="Online Payment Options"
        />
    ),
    onlinePaymentDescription: (
        <FormattedMessage
            id="ContactHelpArticles.onlinePaymentDescription"
            defaultMessage="For your convenience, we offer multiple payment methods within our online checkout."
        />
    ),
    shippingOverview: (
        <FormattedMessage
            id="ContactHelpArticles.shippingOverview"
            defaultMessage="Shipping Overview"
        />
    ),
    shippingOverviewDescription: (
        <FormattedMessage
            id="ContactHelpArticles.shippingOverviewDescription"
            defaultMessage="Learn more about 1stDibs' shipping services: white glove, front door, standard, express, and courier."
        />
    ),
    applyingToSell: (
        <FormattedMessage
            id="ContactHelpArticles.applyingToSell"
            defaultMessage="Applying to Sell on 1stDibs"
        />
    ),
    applyingToSellDescription: (
        <FormattedMessage
            id="ContactHelpArticles.applyingToSellDescription"
            defaultMessage="We thoroughly vet all our sellers for product quality and outstanding customer service."
        />
    ),
    gettingItemAppraised: (
        <FormattedMessage
            id="ContactHelpArticles.gettingItemAppraised"
            defaultMessage="Getting an Item Appraised"
        />
    ),
    gettingItemAppraisedDescription: (
        <FormattedMessage
            id="ContactHelpArticles.gettingItemAppraisedDescription"
            defaultMessage="Although 1stDibs does not offer appraisal services, you may be able to find a similar item with comparable prices and details."
        />
    ),
    sellingPersonalItem: (
        <FormattedMessage
            id="ContactHelpArticles.sellingPersonalItem"
            defaultMessage="Selling a Personal Item"
        />
    ),
    sellingPersonalItemDescription: (
        <FormattedMessage
            id="ContactHelpArticles.sellingPersonalItemDescription"
            defaultMessage="Learn more about applying to sell on 1stDibs and the approval process."
        />
    ),
};

export default copy;
